<div class="flex flex-column text-center p-1 z-2 brand-container">
    <img class="w-13rem lg:w-11 xl:w-11 cursor-pointer" src="assets/images/logo_iir.png" alt="Industrial Info Logo" (click)="goDashboard()">
    <span class="text-white text-bold font-italic text-lg">{{title}} - {{subtitle}}</span>
</div>